import React, { memo, useCallback, useEffect, useState } from 'react';

import {
  IconInsta01,
  IconArrowRight04,
} from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import {
  addAsIsMWebDomain,
  addAsIsPcWebDomain,
} from '@wconcept/wconcept-common/utils/domainUtil';
import type { AgentOnBoardingYn } from '@wconcept/wconcept-common/models/renewal/datadog';
import * as S from './style';

interface FooterDesktopProps {
  agentOnBoardingYn?: AgentOnBoardingYn;
}

const FooterDesktop = ({ agentOnBoardingYn }: FooterDesktopProps) => {
  const [companyUrl, setCompanyUrl] = useState('');
  const [eBuyerUrl, setEBuyerUrl] = useState('');
  const [newsUrl, setNewsUrl] = useState('');
  const [customerUrl, setCustomerUrl] = useState('');
  const [customerCenterUrl, setCustomerCenterUrl] = useState('');
  const [marketingUrl, setMarketingUrl] = useState('');
  const [privacyUrl, setPrivacyUrl] = useState('');
  const [locationUrl, setLocationUrl] = useState('');

  useEffect(() => {
    const fetchUrls = async () => {
      const company = await addAsIsMWebDomain('/Etc/Company');
      const eBuyer = await addAsIsMWebDomain('/Etc/eBuyer');
      const news = await addAsIsMWebDomain('/CustomerCenter/News');
      const customer = await addAsIsMWebDomain('/CustomerAgreement');
      const marketing = await addAsIsMWebDomain('/Etc/Marketting');
      const privacy = await addAsIsMWebDomain('/CustomerPrivacy');
      const customerCenter = await addAsIsMWebDomain('/CustomerCenter');
      const location = await addAsIsMWebDomain('/LocationAgreement');

      setCompanyUrl(company);
      setEBuyerUrl(eBuyer);
      setMarketingUrl(marketing);
      setNewsUrl(news);
      setCustomerUrl(customer);
      setPrivacyUrl(privacy);
      setCustomerCenterUrl(customerCenter);
      setLocationUrl(location);
    };

    fetchUrls();
  }, []);

  // ITEM RENDERER : getLeftRender
  const getLeftRender = useCallback(
    () => (
      <>
        <nav className="box-nav">
          <ul className="nav-util">
            <li>
              <a href={companyUrl} target="_blank" rel="noreferrer">
                회사소개
              </a>
            </li>
            <li>
              <a href={eBuyerUrl} target="_blank" rel="noreferrer">
                입점상담
              </a>
            </li>
            <li>
              <a href={marketingUrl} target="_blank" rel="noreferrer">
                제휴문의
              </a>
            </li>
            <li>
              <a
                href="https://ads.wconcept.co.kr/"
                target="_blank"
                rel="noreferrer"
              >
                광고안내
              </a>
            </li>
            <li>
              <a
                href="https://wconceptpartner.co.kr/"
                target="_blank"
                rel="noreferrer"
              >
                파트너라운지
              </a>
            </li>
            <li>
              <a
                href="https://career.wconcept.co.kr/"
                target="_blank"
                rel="noreferrer"
              >
                채용정보
              </a>
            </li>
            <li>
              <a
                href="https://www.wconcept.com/category/women.html?canonical_uri=%2F"
                target="_blank"
                rel="noreferrer"
              >
                GLOBAL
              </a>
            </li>
          </ul>
          <ul className="nav-terms">
            <li>
              <a href={newsUrl} target="_blank" rel="noreferrer">
                공지사항
              </a>
            </li>
            <li>
              <a href={customerUrl} target="_blank" rel="noreferrer">
                이용약관
              </a>
            </li>
            {agentOnBoardingYn === 'Y' && (
              <li>
                <a href={locationUrl} target="_blank" rel="noreferrer">
                  <strong>위치정보이용약관</strong>
                </a>
              </li>
            )}
            <li>
              <a href={privacyUrl} target="_blank" rel="noreferrer">
                <strong>개인정보처리방침</strong>
              </a>
            </li>
          </ul>
        </nav>
        <div className="help">
          <h3 className="title">
            <a href={customerCenterUrl} target="_blank" rel="noreferrer">
              고객센터 <IconArrowRight04 />
            </a>
          </h3>
          <div className="column">
            <a
              href={customerCenterUrl}
              target="_blank"
              rel="noreferrer"
              className="tel"
            >
              1566-5027<span className="time">(09:00~18:00)</span>
            </a>
            <a
              href="//www.instagram.com/wconceptkorea/"
              className="insta"
              target="_blank"
              rel="noreferrer"
            >
              <IconInsta01 />
            </a>
          </div>
        </div>
      </>
    ),
    [
      companyUrl,
      customerCenterUrl,
      customerUrl,
      eBuyerUrl,
      agentOnBoardingYn,
      locationUrl,
      marketingUrl,
      newsUrl,
      privacyUrl,
    ]
  );

  // ITEM RENDERER : getRightRender
  const getRightRender = () => (
    <>
      <div className="address">
        <h3 className="title">㈜더블유컨셉코리아</h3>
        <ul className="list">
          <li>대표자 : 이지은</li>
          <li>
            주소 : 서울특별시 영등포구 영신로34길 30, 1~2층 (영등포동,
            KB영등포타워)
          </li>
          <li>사업자등록번호 : 211-88-19183</li>
          <li>
            통신판매업신고 : 제2025-서울영등포-0492호{' '}
            <a
              href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2118819183&apv_perm_no="
              target="_blank"
              rel="noreferrer"
              className="micro-btn"
            >
              사업자정보확인
            </a>
          </li>
          <li>개인정보보호책임자 : 허선희</li>
          <li>호스팅서비스 : ㈜더블유컨셉코리아</li>
          <li>
            고객센터 :{' '}
            <a
              className="tel"
              href={customerCenterUrl}
              target="_blank"
              rel="noreferrer"
            >
              1566-5027
            </a>
          </li>
          <li>
            이메일 :{' '}
            <a
              className="tel"
              href="mailto:cs_help@wconcept.co.kr"
              target="_blank"
              rel="noreferrer"
            >
              cs_help@wconcept.co.kr
            </a>
          </li>
          <li>운영시간 : 평일 09:00~18:00 (점심시간 : 12:30~13:30)</li>
          <li className="offline_store">
            오프라인 매장 : W한남 (서울시 용산구 이태원로54길 23)
          </li>
          <li>COPYRIGHT ⓒ ㈜더블유컨셉코리아 ALL RIGHTS RESERVED.</li>
        </ul>
      </div>
      <div className="aside">
        <h3 className="title">소비자피해보상보험</h3>
        <ul className="list">
          <li>
            고객님은 안전거래를 위해 현금 결제 시, Wconcept 에서 가입한
            소비자피해보상보험 서비스를 이용하실 수 있습니다.
          </li>
          <li>
            보상대상 : 미배송/반품, 환불거부/쇼핑몰부도
            <a
              href={`${process.env.NEXT_PUBLIC_WCONCEPT_DISPLAY_WEB}/rn/escrow`}
              target="_blank"
              className="micro-btn"
              rel="noreferrer"
            >
              서비스 가입사실 확인
            </a>
          </li>
        </ul>
      </div>
    </>
  );

  return (
    <S.FooterDesktop id="footer">
      <div className="inner-footer">
        <div className="left">{getLeftRender()}</div>
        <div className="right">{getRightRender()}</div>
      </div>
      <div className="desc">
        (주)더블유컨셉코리아는 W컨셉에 입점한 개별 판매자가 판매하는 상품에
        대해서는 통신판매중개자로서 통신판매의 당사자가 아니며, 입점 판매자가
        등록한 상품정보 및 거래 등에 대해 책임을 지지 않습니다.
        <br />
        개별 상품 페이지 등에서 해당 판매자 정보를 확인하시기 바랍니다.
      </div>
    </S.FooterDesktop>
  );
};

export default memo(FooterDesktop);
